import { Card, CardContent, Typography, makeStyles } from '@material-ui/core';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  chartWrapper: {
    width: '100%',
    height: 300,
    marginTop: theme.spacing(1),
  },
}));

const ENV_COLORS: Record<string, string> = {
  production: '#d32f2f',
  hml: '#1976d2',
  development: '#388e3c',
  staging: '#f57c00',
  training: '#7b1fa2',
  cron: '#00838f',
  unknown: '#757575',
};

const FALLBACK_COLORS = ['#5c6bc0', '#26a69a', '#ef5350', '#ab47bc', '#ffa726'];

interface EnvironmentPieChartProps {
  byEnvironment: Record<string, number>;
}

export const EnvironmentPieChart = ({
  byEnvironment,
}: EnvironmentPieChartProps) => {
  const classes = useStyles();
  const entries = Object.entries(byEnvironment);

  const chartData = entries.map(([env, count]) => ({
    name: env,
    value: count,
  }));

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.content}>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Distribuição por Ambiente
        </Typography>
        {chartData.length === 0 ? (
          <Typography color="textSecondary" variant="body2">
            Nenhum dado disponível
          </Typography>
        ) : (
          <div className={classes.chartWrapper}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={100}
                  paddingAngle={2}
                  dataKey="value"
                  label={({ name, percent }) => {
                    const pct = percent * 100;
                    const display = pct < 1 && pct > 0 ? pct.toFixed(1) : pct.toFixed(0);
                    return `${name} (${display}%)`;
                  }}
                  labelLine={false}
                >
                  {chartData.map((entry, index) => (
                    <Cell
                      key={entry.name}
                      fill={
                        ENV_COLORS[entry.name] ??
                        FALLBACK_COLORS[index % FALLBACK_COLORS.length]
                      }
                    />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value: number) => [value, 'Deploys']}
                />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
